import { useSearchParams } from "react-router-dom";
import { BookOpen, Home, FileText, CalendarCheck, HandCoins, TrendingUp } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { PageTitle, Chip } from "@/components/ui-kit";
import CashJournal from "@/components/finance/CashJournal";
import HouseRegister from "@/components/finance/HouseRegister";
import Invoices from "@/components/finance/Invoices";
import DayClose from "@/components/finance/DayClose";
import Collections from "@/components/finance/Collections";
import NetProfit from "@/components/finance/NetProfit";

const TABS = [
  { k: "journal", icon: BookOpen, label: "fin_cash_journal" },
  { k: "house", icon: Home, label: "fin_house_register" },
  { k: "invoices", icon: FileText, label: "fin_invoices" },
  { k: "day", icon: CalendarCheck, label: "fin_day_close" },
  { k: "collections", icon: HandCoins, label: "fin_collections" },
  { k: "profit", icon: TrendingUp, label: "np_title", owner: true },
];

export default function Finance() {
  const { t, staff, view } = useApp();
  const fx = view.shop?.type === "exchange";
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") || "journal";
  const setTab = (k) => setParams(() => new URLSearchParams({ tab: k }), { replace: true });
  return (
    <div data-testid="finance-page">
      <PageTitle testid="finance-title">{t("rb_finance")}</PageTitle>
      <div className="flex flex-wrap gap-2 mb-4" data-testid="finance-tabs">
        {TABS.filter((x) => (!x.owner || staff?.role === "owner") && (!fx || ["journal", "day", "profit"].includes(x.k))).map(({ k, icon: Icon, label }) => <Chip key={k} active={tab === k} onClick={() => setTab(k)} data-testid={`finance-tab-${k}`}><Icon className="w-4 h-4 me-1" />{t(label)}</Chip>)}
      </div>
      {tab === "journal" && <CashJournal />}
      {tab === "house" && <HouseRegister />}
      {tab === "invoices" && <Invoices key={params.toString()} />}
      {tab === "day" && <DayClose />}
      {tab === "collections" && <Collections key={params.toString()} />}
      {tab === "profit" && <NetProfit />}
    </div>
  );
}
